class MinReducer {
  initialValue() {
    return null;
  }

  reduce(result, value) {
    if (result === null) {
      // First result
      return value;
    }

    return Math.min(result, value);
  }
}

export default MinReducer;